import {connect} from "react-redux";
import {useLocation, useNavigate} from "react-router-dom";
import {getHomeInternalUrl} from "../constants/appRoutes";
import Call from "../hocs/call";
import {showUserSetPasswordForm} from "../state/user/userActions";

const mapDispatchToProps = dispatch => ({
  onUserSetPasswordFormShow: token => dispatch(showUserSetPasswordForm(token))
});

const ResetPasswordDomain = ({onUserSetPasswordFormShow, children}) => {
  const location = useLocation();
  const navigate = useNavigate();

  const tokenParam = new URLSearchParams(location.search).get("token");

  if (!tokenParam) {
    navigate(getHomeInternalUrl());
  }

  return (
    <Call cb={onUserSetPasswordFormShow} cbParam={tokenParam} disabled={!tokenParam}>
      {children}
    </Call>
  );
};

export default connect(null, mapDispatchToProps)(ResetPasswordDomain);
